export function ourMissionParallax() {
    const $window = $(window);
    const cloudRight = $(".cloud-right");
    const cloudLeft = $(".cloud-left");
    $(window).on("scroll load", function () {
        const $winTop = $(this).scrollTop();
        const $sectionTop = $(".our-mission").offset().top;
        const $scrollPosition = $winTop - $sectionTop;

        if ($winTop > $sectionTop && $winTop < ($sectionTop + $window.innerHeight())) {
            if ($window.width() >= 768) {
                $(".gradient-card").css("transform", `translateY(${$scrollPosition * 0.05}px)`);
            }
            cloudLeft.css("transform", `translateX(${$scrollPosition * 0.2}px)`);
            cloudRight.css("transform", `translateX(-${$scrollPosition * 0.2}px)`);
        }

        if ($winTop > ($sectionTop - 300) && $winTop < ($sectionTop + $window.innerHeight())) {
            $(".clouds").css("transform", `translateY(${$scrollPosition * 0.1}px)`);
        } else {
            $(".clouds").css("transform", "-29.9px");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourMissionParallax.js